import React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { setSelectedTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import { AdminConfigNavConsts, AdminConfigTabMap } from 'src/store/adminConfigPageSlice/common/constants';
import { useAppSelector } from 'src/store/store';

/**
 * Default Component
 */
const TabGroup = () => {
  const { selectedTab } = useAppSelector((state) => state.adminConfigPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <TabGroupLib
      value={selectedTab}
      onChange={(newTab) => {
        dispatch(setSelectedTab(newTab));
        navigate(AdminConfigTabMap.get(newTab), { replace: true });
      }}
    >
      <Tab value={AdminConfigNavConsts.Site.TAB}>Site Configuration</Tab>
      <Tab value={AdminConfigNavConsts.Task.root.TAB}>Task Configuration</Tab>
      <Tab value={AdminConfigNavConsts.Form.root.TAB}>Work/Requirement Form Configuration</Tab>
      <Tab value={AdminConfigNavConsts.Modification.TAB}>Task Modification Configuration</Tab>
    </TabGroupLib>
  );
};

export default TabGroup;
